import { createFileRoute } from '@tanstack/react-router';
import FolderPermissionsView from '../../components/PermissionsView/FolderPermissionsView';

type FolderSearch = {
  // Exchange folder id of the selected folder. Passing it along saves the API a translation of the
  // Graph folder id on every permission request.
  exchangeFolderId?: string;
  // Display name of the selected folder. The folder tree already knows it, so the permission
  // endpoints do not have to return it.
  folderName?: string;
};

export const Route = createFileRoute('/_auth/folder/$folderId')({
  validateSearch: (search: Record<string, unknown>): FolderSearch => ({
    exchangeFolderId: typeof search.exchangeFolderId === 'string' ? search.exchangeFolderId : undefined,
    folderName: typeof search.folderName === 'string' ? search.folderName : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { folderId: graphFolderId } = Route.useParams();
  const { exchangeFolderId, folderName } = Route.useSearch();

  return <FolderPermissionsView graphFolderId={graphFolderId} exchangeFolderId={exchangeFolderId} folderName={folderName} />;
}
